<template>
  <div class="about">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <!-- 轮播 -->
    <el-row>
      <el-col :span="24">
        <div class="auto">
          <el-carousel height="560px" arrow="always" :interval="liuqian" trigger="click">
            <el-carousel-item v-for="(item, index) in ChartList" :key="index">
                 <el-image :src="item.picture" @click="clickOnTheCarousel(item)" alt=""></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>


    <div class="content">
      <!-- 实验室简介 -->
      <div style="padding: 70px 0px">
        <el-row>
          <el-col :span="24">
            <div class="auto">
              <h1>{{ $t("menu.qiye") }}</h1>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="auto">
              <el-divider></el-divider>
            </div>
          </el-col>
        </el-row>
        <div v-for="(itemy, indexy) in SelectList" :key="indexy">
          <el-row v-if="itemy.category === 'Brief'">
            <el-col :span="12">
              <div class="auto">
                <el-col :span="24">
                  <h2>{{ itemy.title }}</h2>
                </el-col>
              </div>
              <div class="auto">
                <el-col :span="24">
                  <p>
                    {{ ellipsiser(itemy.explain) }}
                  </p>
                </el-col>
              </div>
              <el-col :span="24">
                <router-link to="/EnterpriseProfile">
                  <el-button type="primary" class="Btn-primary" round>{{
                    $t("menu.viewMore")
                  }}</el-button></router-link
                >
              </el-col>
            </el-col>

            <el-col :span="12">
              <div class="auto">
                <el-image
                  style="width: 580px; height: 322px"
                  :src="itemy.cover"
                ></el-image>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 检测范围 -->
    <div style="padding: 70px 0px; background: #ffffff">
      <div class="content">
        <el-row>
          <el-col :span="24">
            <div class="auto">
              <h1>{{ $t("menu.business") }}</h1>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="auto">
              <el-divider></el-divider>
            </div>
          </el-col>
        </el-row>

        <!-- 左边 -->
        <el-row :gutter="20">
          <el-col style="display: flex;">
            <div v-for="(itemq, indexq) in SelectList" :key="indexq">
              <template v-if="itemq.category == 'Business'">
                <el-col>
                  <div class="back">
                    <el-image class="cover" :src="itemq.cover"></el-image>
                    <h4 class="XiaoJiao">{{ itemq.title }}</h4>
                    <div style=" text-align: left;" >
                      <p class="hideen" style="margin:0px 10px; " v-html="itemq.explain"> </p>
                    </div>
                    <el-col :span="6" :offset="9">
                      <router-link :to="itemq.routePath">
                        <el-button size="mini" class="details" round >{{ $t("menu.particulars") }}</el-button >
                      </router-link >
                    </el-col>
                  </div>
                </el-col>
              </template>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 客户检测须知 -->
    <!-- <div style="height: 263px; background: #f8f9fd">
      <div class="content">
        <el-row style="padding: 72px 0px;   text-align: center;">
          <el-col :span="24">
            <h1>{{ $t("menu.CustomerInstructions") }}</h1>
          </el-col>

          <el-col :span="24">
            <i class="i"></i>
          </el-col>
          <el-col :span="24">
            <p>{{ $t("menu.regulations") }}</p>
          </el-col>
          <el-col :span="24">
            <router-link to="/CustomerInspection">
              <el-button type="primary" class="Btn-primary xqin" round>
                {{ $t("menu.particulars") }}</el-button
              ></router-link
            >
          </el-col>
        </el-row>
      </div>
    </div> -->

    <!-- 实验室中心 -->
    <div style="padding: 70px 0px">
      <div class="content">
        <el-row>
          <el-col :span="24">
            <div class="auto">
              <h1>{{ $t("menu.LaboratoryCenter") }}</h1>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="auto">
              <el-divider></el-divider>
            </div>
          </el-col>
        </el-row>
      
          <div v-for="(itemshi, indexshi) in SelectList" :key="indexshi">
            <el-row v-if="itemshi.category === 'LAB'" >
              <!-- <el-col :span="6">
                <el-col :span="24">
                  <el-image
                    style="width: 300px; height: 442px"
                    :src="shebei1"
                  ></el-image>
                </el-col>
              </el-col>
             -->
              
                  <el-col :span="16">
                      <router-link to="/LaboratoryCenter">
                        <div style="width: 780px; height: 610px; background: #ffffff">
                          <el-col :span="24">
                            <el-image
                              style="width: 780px; height: 460px"
                              :src="itemshi.cover"
                            ></el-image>
                          </el-col>
                          <el-col :span="24" style="color: #1d2088">
                            <h3 class="">{{ itemshi.title }}</h3>
                          </el-col>
                          <el-col :span="24" style="padding: 10px 15px">
                            <span class="explain">
                              {{ ellipsiser(itemshi.explain) }}
                            </span>
                          </el-col>
                        </div>
                     </router-link>
                  </el-col>
                <el-col :span="8">

                <div class="shiyanzx">
                  <el-col :span="24">
                      <el-image
                        style="width: 380px; height: 207px"
                        :src="imgweizhi">
                      </el-image>
                  </el-col>
                     <div v-for="(itemProjectList,indexli) in ProjectList" :key="indexli">
                        <el-col :span="24" v-if="itemProjectList.id==4 ||itemProjectList.id==5||itemProjectList.id==6" >
                          <h3 style="color:#333333">{{itemProjectList.region}}</h3>
                          <ul style="margin-left:15px">
                          <li>  
                            <!-- <el-col :span="6"> -->
                                <el-image style="width: 28px; height: 28px;position: relative; top: 10px;"   :src="dizhi"> </el-image> 
                              <!-- <span class="company"> -->
                               {{ $t("menu.companyAddress") }}
                                  <span style="text-align: center;">{{itemProjectList.companyAddress}}</span>
                                   <!-- </span> -->
                               <!-- </el-col> -->
                            </li>
                            <li>     
                              <!-- <el-col :span="6"> -->
                                  <el-image style="width: 28px; height: 28px;position: relative; top: 10px;"  :src="dianhua"> </el-image>
                                  {{ $t("menu.tel") }}
                           <!-- </el-col>   -->
                                 <!-- <el-col :span="20"> -->
                                   <span>{{itemProjectList.tel}}</span>
                                 <!-- </el-col> -->
                             </li>
                            <li>   
                              <!-- <el-col :span="6"> -->
                                <el-image style="width: 28px; height: 28px;position: relative; top: 10px;"   :src="chuanzhen"> </el-image> 
                                {{ $t("menu.fax") }}    
                             <!-- </el-col>   -->
                                   <!-- <el-col :span="20"> -->
                                      <span>{{itemProjectList.fax}}</span>
                                   <!-- </el-col> -->
                             </li>
                            <li>   
                              <!-- <el-col :span="6"> -->
                                <el-image style="width: 28px; height: 28px;position: relative; top: 10px;"    :src="youxiang"> </el-image>  
                                {{ $t("menu.mailbox") }}
                            <!-- </el-col>   -->
                            <!-- <el-col :span="20">  -->
                              <span>{{itemProjectList.mailbox}}</span>
                              <!-- </el-col> -->
                            </li>
                          
                            <li>    
                                <!-- <el-col :span="6"> -->
                                <el-image style="width: 28px; height: 28px;position: relative; top: 10px;"   :src="shijian"> </el-image> 
                                  {{ $t("menu.businessHours") }}
                                <!-- </el-col>  -->
                                <!-- <el-col :span="20"> -->
                                   <span>{{itemProjectList.businessHours}}</span>
                                   <!-- </el-col> -->
                            </li>
                          </ul>
                        </el-col>
                     </div>
                </div> 
              </el-col> 


            </el-row>
          </div>


      </div>
    </div>

    <!-- 新闻资讯 -->
    <div style="padding: 70px 0px; background: #ffffff">
      <div class="content">
        <el-row>
          <el-col :span="24">
            <div class="auto">
              <h1>{{ $t("menu.New") }}</h1>
            </div>
          </el-col>
        </el-row>

        <el-row type="flex" justify="center">
          <el-col :span="1" :offset="11">
            <el-divider></el-divider>
          </el-col>
          <!-- -->
          <el-col :span="2" :offset="9">
            <router-link to="/CompanyDnamic">
              <p>{{ $t("menu.viewMore") }}</p></router-link
            >
          </el-col>
          <!-- </router-link> -->
        </el-row>

        <el-row >
          <el-col :span="6" v-for="(newItem, indexnew) in NewsList" :key="indexnew">
            <div style="width: 280px; height: 391px; background: #f2f2f2">
              <el-col :span="24">
                <el-image
                  style="width: 280px; height: 158px"
                  :src="newItem.cover"
                ></el-image>
                <h3>{{ newItem.title }}</h3>
              </el-col>
              <el-col :span="24">
                <p>
                  {{ ellipsis(newItem.details) }}
                </p>
              </el-col>

              <el-col :span="12" :offset="12">
                <span>{{ newItem.releaseDate }}</span>
              </el-col>

              <el-col :span="9" :offset="15">
                <el-button
                  size="mini"
                  class="details"
                  @click="detailPage(newItem)"
                  round
                  >{{ $t("menu.particulars") }}</el-button >
              </el-col>
            </div>
          </el-col>

          
        </el-row>
      </div>
    </div>

    <!-- 传送门 -->
    <!-- <div style="padding: 70px 0px">
      <div class="content">
        <el-row>
          <el-col :span="24">
            <div class="auto">
              <h1>{{ $t("menu.portal") }}</h1>
            </div>
          </el-col>
        </el-row>

        <el-row type="flex" justify="center">
          <el-col :span="24">
            <div class="auto">
              <el-divider></el-divider>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <router-link to="/TheReportQuery">
              <div class="align">
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <el-image
                        style="width: 35px; height: 34px"
                        :src="YeCenterYi"
                      ></el-image>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <h3>{{ $t("menu.TheReportQuery") }}</h3>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </router-link>
          </el-col>

          <el-col :span="6">
            <router-link to="/TestApplicationForm">
              <div class="align">
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <el-image
                        style="width: 35px; height: 34px"
                        :src="YeCenterEr"
                      ></el-image>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <h3>{{ $t("menu.ApplicationForm") }}</h3>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </router-link>
          </el-col>

          <el-col :span="6">
            <router-link to="/TheInspectionProcess">
              <div class="align">
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <el-image
                        style="width: 35px; height: 34px"
                        :src="YeCenterSan"
                      ></el-image>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <h3>{{ $t("menu.TheInspectionProcess") }}</h3>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </router-link>
          </el-col>

          <el-col :span="6">
            <router-link to="/Recruitment">
              <div class="align">
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <el-image
                        style="width: 35px; height: 34px"
                        :src="YeCenterSi"
                      ></el-image>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="auto">
                      <h3>{{ $t("menu.Recruitment") }}</h3>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div> -->

    <!-- 底部logo -->
    <div style="background: #ffffff">
      <div class="content">
        <el-row>
          <el-col :span="8">
            <div style="padding: 35px 0px; width: 380px">
              <el-row>
                <el-col :span="24">
                  <div class="auto">
                    <a href="http://www.sealtech.com/" target="_blank">
                      <el-image
                        style="width: 380px; height: 80px"
                        :src="dibulogoYi"
                      ></el-image>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>

          <el-col :span="8">
            <div style="padding: 35px 0px; width: 380px">
              <el-row>
                <el-col :span="24">
                  <div class="auto">
                    <a href="https://aviation.sealtech.com/" target="_blank">
                      <el-image
                        style="width: 380px; height: 80px"
                        :src="dibulogoEr"
                      ></el-image>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>

          <el-col :span="8">
            <div style="padding: 35px 0px; width: 380px">
              <el-row>
                <el-col :span="24">
                  <div class="auto">
                    <a href="http://www.sealtools.com/" target="_blank">
                      <el-image
                        style="width: 380px; height: 80px"
                        :src="dibulogoSan"
                      ></el-image>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0px;
}


ul li,ul li>span{
  color: #999999;
  font-size: 16px;
  line-height: 30px;
  padding: 5px;
}
.explain{
  font-size: 16px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.hideen{
  margin:0px 10px;    
  width:360px;
  height: 86px;
  overflow: hidden; /*文字超出时隐藏*/
  text-overflow: ellipsis; /*文本溢出时，显示省略符号*/
  word-break: break-all; /*英文自动换行*/

  /*webkit私有属性，仅支持webkit核*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp:4;  /*显示行数*/
}
.hideen /deep/p{
margin: 0px 10px !important;
}
.cover {
  width: 44px;
  height: 44px;
}
.RightImg{
  height: 610px;
  width: 380px;
}
/deep/ .el-carousel__indicator.is-active button {
  background: #333333;
}
/deep/ .el-carousel__button {
  /* border: 1px solid #333333; */
  width: 12px;
  height: 12px;
  border: 1px solid #333333;
  border-radius: 50%;
}
.xqin {
  margin: 0px !important;
}

.i {
    width: 58px;
    margin-left: 48%;
    display: block;
    border-bottom: 2px solid #2DC6EA;
}
/deep/ .el-carousel__arrow {
  font-size: 20px;
  z-index: 4;
  background-color: #ffffff;
  color: #000a48;
  margin: 0px 264px;
}
/deep/ .el-carousel__arrow--left:hover,
.el-carousel__arrow--left:focus {
  background-color: #ffffff;
  color: #000a48;
}
/deep/ .el-carousel__arrow--right:hover,
.el-carousel__arrow--right:focus {
  background-color: #ffffff;
  color: #000a48;
}
.about {
  background: #f2f2f2;
}
.el-carousel--horizontal {
  width: 1920px;
}

.el-carousel__container {
  width: 1920px;
}
.back {
    width: 380px;
    height: 240px;
    background: #f2f2f2;
    margin-bottom: 11px;
    text-align: center;
    padding: 30px 0px;
}

.el-carousel {
  margin-top: 161px;
}
h1 {
  font-size: 30px;

  font-weight: 600;
  margin: 0px;
}

h2 {
  font-size: 26px;
}
h3 {
  font-size: 20px;
  margin-bottom: 0px;
  margin-left: 15px;
  font-weight: 400;
  color:#333333;
}
h3:hover,h3:focus {
  color: #1d2088;
  font-weight: bold;
}

span {
  font-size: 12px;
  color: #cccccc;
}

.XiaoJiao {
    font-size: 20px;
    margin: 15px 0px;
}
p {
  color: #999999;
  font-size: 16px;
  padding: 0px 10px;
}
.el-divider {
  width: 54px;
  margin-top: 8px;
  border-bottom: 1px solid #2DC6EA;
  margin-bottom: 50px;
}
.shiyanzx {
  width: 380px;
  height: 610px;
  background: #ffffff;
  margin-left: 10px;
}
.align {
  text-align: center;
  display: -webkit-flex ;
  display: flex;
  background: hsl(0, 0%, 100%);
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 210px;
  width: 280px;
}
</style>

<script>
export default {
  name: "about",
  data() {
    return {
      number: "1",
      shebei1: require("@/assets/images/about/shiyanyi.jpg"),
      YeCenterYi: require("@/assets/images/about/icon_chaxun.png"),
      YeCenterEr: require("@/assets/images/portal/jiancesqing.svg"),
      YeCenterSan: require("@/assets/images/portal/jiancezixun.svg"),
      YeCenterSi: require("@/assets/images/about/zhaopin.png"),
      // 底部logo
      dibulogoYi: require("@/assets/images/about/logosan.png"),
      dibulogoEr: require("@/assets/images/about/logosi.svg"),
      dibulogoSan: require("@/assets/images/about/logowu.png"),

      // img_weizhi.jpg
      imgweizhi:require("@/assets/images/LaboratoryLogo/img_weizhi.jpg"),
      dizhi:require("@/assets/images/LaboratoryLogo/dizhi.png"),
      dianhua:require("@/assets/images/LaboratoryLogo/dianhua.png"),
      chuanzhen:require("@/assets/images/LaboratoryLogo/chuanzhen.png"),
      youxiang:require("@/assets/images/LaboratoryLogo/youxiang.png"),
      shijian:require("@/assets/images/LaboratoryLogo/shijian.png"),

      SelectList: [],
      ChartList: [],
      NewsList: [],
      ContactList: [],
      ProjectList:[],
      title: "",
      coverimg:"",
      liuqian:6000,
    };
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelect();
    this.getSelectRubber()
  },
  // 截取
  computed: {
    ellipsis() {
      return function (value) {
        if (!value) return "";
        value = value.replace(/<[^>]+>/g, "");
        if (value.length > 40) {
          console.log(value.slice(0, 40));
          return value.slice(0, 40) + "...";
        }
        return value;
      };
    },
    ellipsiser() {
      return function (value) {
        if (!value) return "";
        value = value.replace(/<[^>]+>/g, "");
        if (value.length > 180) {
          console.log(value.slice(0, 180));
          return value.slice(0, 180) + "...";
        }
        return value;
      };
    },

  },
  methods: {
    // 联系信息数据
    async getSelectRubber() {
      const { data: res } = await this.$http.get(
        "/ContactUs/GetContactInfo",
        {    
          params:{languageType: this.title },
        }
      );
      if (res.code !== 200) return console.log("数据请求失败! ");
      this.ProjectList = res.data;
    },

    async getSelect() {
      console.log(this.title);
      const { data: res } = await this.$http.get("/AboutUs/GetAboutUs", {
        params: { languageType: this.title },
      });

      if (res.code !== 200) return console.log("数据请求失败! ");
      // --关于公司，根据类别字段(category)获取对应信息：Brief =＞ 企业简介；Business =＞ 业务范围；LAB =＞ 实验室介

      // --轮播图片
      this.ChartList = res.data.chart; 

      // --新闻信息
      this.NewsList = res.data.news;
      // -联系方式
      this.ContactList = res.data.contact; 
      this.SelectList = res.data.brief;
      this.coverimg=res.data.imageUrl
    },  

    // 新闻详情页面  
    detailPage(val) {
      if (val.category == "Company") { 
        this.$router.push({  
          path: "/CompanyDnamic/Particulars",
          query: { ti: val.pid, category: val.category },
        }); 
      } else { 
        this.$router.push({ 
          path: "/IndustryInformation/Particulars",
          query: { ti: val.pid, category: val.category },
        }); 
      } 
    },

    // 轮播点击事件
    clickOnTheCarousel(item) {
      if (item.sort == 1) {
        let op = this.$router.resolve({name: "PdfView",query: {'pdfFile': 'https://lab.sealtech.com/wwwroot/Images/certificate/20241202/362e9b367200481194d026a8b2b3a8e6.pdf'}})
        window.open(op.href,'_blank')
      }
      else {
        if (item.pcRoute != '') {
          this.$router.push({ path: item.pcRoute})
        }
      }
    }
  },
};
</script>





